/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Author_YouInputs */

const en_us2_draft_author_you = /** @type {(inputs: Draft_Author_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your draft`)
};

const pt_br2_draft_author_you = /** @type {(inputs: Draft_Author_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu rascunho`)
};

const es_419_draft_author_you = /** @type {(inputs: Draft_Author_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu borrador`)
};

const pt_pt2_draft_author_you = /** @type {(inputs: Draft_Author_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu rascunho`)
};

const fr_fr2_draft_author_you = /** @type {(inputs: Draft_Author_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton brouillon`)
};

const de_de2_draft_author_you = /** @type {(inputs: Draft_Author_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Entwurf`)
};

const it_it2_draft_author_you = /** @type {(inputs: Draft_Author_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua bozza`)
};

/**
* | output |
* | --- |
* | "Your draft" |
*
* @param {Draft_Author_YouInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_author_you = /** @type {((inputs?: Draft_Author_YouInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Author_YouInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_author_you(inputs)
	if (locale === "es-419") return es_419_draft_author_you(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_author_you(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_author_you(inputs)
	if (locale === "de-DE") return de_de2_draft_author_you(inputs)
	if (locale === "it-IT") return it_it2_draft_author_you(inputs)
	return en_us2_draft_author_you(inputs)
});
export { draft_author_you as "draft.author_you" }